import type { GA4FilterItem } from 'src/utils/gql/types';

/** Chiavi filtri Shopify compatibili con MetricValuesArgs (stesso schema usato da Inventory). */
const SHIPPING_COUNTRY_KEY = 'shipping_country';
const CUSTOMER_TYPE_KEY = 'customer_type';
const PRODUCT_TAG_KEY = 'product_tag';
const COLLECTION_TITLE_KEY = 'collection_title';
const VENDOR_KEY = 'vendor';
const PRODUCT_TYPE_KEY = 'product_type';

const FILTER_OPERATOR_IN = 'IN';

/**
 * Costruisce l'array di filtri per le query metriche (Shopify/Kipify/Custom Formula)
 * a partire dagli stati UI usati anche in Inventory.
 */
export function buildKpiFilters(params: {
  countries: string[];
  customerType: string;
  tags: string[];
  collections: string[];
  vendors: string[];
  productTypes: string[];
}): GA4FilterItem[] {
  const filters: GA4FilterItem[] = [];

  if (params.countries.length > 0) {
    filters.push({
      key: SHIPPING_COUNTRY_KEY,
      filterGroupOr: [
        {
          rulesAnd: [
            { operator: FILTER_OPERATOR_IN, values: params.countries },
          ],
        },
      ],
    });
  }
  if (params.customerType) {
    filters.push({
      key: CUSTOMER_TYPE_KEY,
      filterGroupOr: [
        {
          rulesAnd: [
            { operator: FILTER_OPERATOR_IN, values: [params.customerType] },
          ],
        },
      ],
    });
  }
  if (params.tags.length > 0) {
    filters.push({
      key: PRODUCT_TAG_KEY,
      filterGroupOr: [
        { rulesAnd: [{ operator: FILTER_OPERATOR_IN, values: params.tags }] },
      ],
    });
  }
  if (params.collections.length > 0) {
    filters.push({
      key: COLLECTION_TITLE_KEY,
      filterGroupOr: [
        {
          rulesAnd: [
            { operator: FILTER_OPERATOR_IN, values: params.collections },
          ],
        },
      ],
    });
  }
  if (params.vendors.length > 0) {
    filters.push({
      key: VENDOR_KEY,
      filterGroupOr: [
        {
          rulesAnd: [{ operator: FILTER_OPERATOR_IN, values: params.vendors }],
        },
      ],
    });
  }
  if (params.productTypes.length > 0) {
    filters.push({
      key: PRODUCT_TYPE_KEY,
      filterGroupOr: [
        {
          rulesAnd: [
            { operator: FILTER_OPERATOR_IN, values: params.productTypes },
          ],
        },
      ],
    });
  }

  return filters;
}
